import { render, staticRenderFns } from "./ArticlesArchive.vue?vue&type=template&id=072f2a16"
import script from "./ArticlesArchive.vue?vue&type=script&lang=js"
export * from "./ArticlesArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports